var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-tag',{staticClass:"state-list",attrs:{"type":_vm.item.type},on:{"click":_vm.item.click}},[_vm._v(_vm._s(_vm.item.text))])}
var staticRenderFns = []

export { render, staticRenderFns }